export const setPropertyByPath = (object, path, value) => {
  let currentProperty = object;

  for (const [index, property] of path.entries()) {
    const isPropertyLast = index === path.length - 1;

    if (isPropertyLast) {
      currentProperty[property] = value;
      return;
    }

    const nextProperty = path[index + 1];
    const isNextPropertyValidIndex = Number.isInteger(nextProperty) && nextProperty >= 0;
    const defaultValueForProperty = (isNextPropertyValidIndex ? [] : {});
    const isCurrentPropertyValid = typeof currentProperty[property] === 'object' && currentProperty[property] !== null;

    currentProperty[property] = isCurrentPropertyValid ? currentProperty[property] : defaultValueForProperty;
    currentProperty = currentProperty[property];
  }
};
